import { Button, SimpleText } from 'platform-components';
import { getExactPathMatch } from 'platform-components/src/utils/getExactPathMatch';
import { withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { bindActionCreators, compose } from 'redux';

import { teamBuilderActions } from 'common.components/team-builder/actions';
import { TEAM_BUILDER_ENTRY_STEPS } from 'common.components/team-builder/typings';
import { getCurrentOrFirstTeamId, getSchoolId } from 'common.components/user/selectors';

import * as classActions from '../class/actions';

import './create-class-button.scss';

export class CreateClassButton extends React.Component {
    static propTypes = {
        schoolId: PropTypes.number,
        setShouldRedirect: PropTypes.func.isRequired,
        teamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        getRouterPath: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        startTeamBuilder: PropTypes.func.isRequired,
    };

    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    state = {
        isModalOpened: false,
    };

    handleClick = () => {
        const { startTeamBuilder, location } = this.props;
        const { staticUrls } = this.context;
        const { path = '' } = getExactPathMatch(staticUrls, location.pathname) || {};

        ym('reachGoal', 'click_add_class', { from: path });
        startTeamBuilder({
            entryPoint: TEAM_BUILDER_ENTRY_STEPS.TEAM,
            onSuccess: this.handleFinishTeamCreation,
        });
    };

    handleFinishTeamCreation = (addedStudentsIds, createdTeamId) => {
        const { setShouldRedirect, history, getRouterPath, location } = this.props;
        const { staticUrls } = this.context;

        let redirectPath = staticUrls.labClasses;
        const { path = '' } = getExactPathMatch(staticUrls, location.pathname) || {};
        const newPath = path.replace('/lab/', '/lab/classes/:classId/');

        if (Object.values(staticUrls).includes(newPath)) {
            redirectPath = newPath;
        } else {
            setShouldRedirect(true, createdTeamId);
        }

        history.push(getRouterPath(redirectPath, { classId: createdTeamId }));
    };

    render() {
        const { teamId } = this.props;

        if (teamId) {
            return null;
        }

        return (
            <>
                <Button onClick={this.handleClick}>
                    <SimpleText id="educationHeaderWrapper.createClass" />
                </Button>
            </>
        );
    }
}

const mapStateToProps = (storeState, ownProps) => {
    const { classId } = ownProps;

    return {
        teamId: getCurrentOrFirstTeamId(storeState, { classId }),
        schoolId: getSchoolId(storeState),
    };
};

const mapDispatchToProps = (dispatch) => {
    const { setShouldRedirect } = classActions;
    const { start: startTeamBuilder } = teamBuilderActions;

    return bindActionCreators(
        {
            startTeamBuilder,
            setShouldRedirect,
        },
        dispatch
    );
};

export default compose(withRouterPath, connect(mapStateToProps, mapDispatchToProps))(CreateClassButton);
